import React, { useState } from 'react';
import MenuOperaciones from '../menuOperaciones';
import OperacionesDia from '../operacionesdia';

function VerOperacionesDia() {
  const [menuOpen, setMenuOpen] = useState(true);
  const sidebarWidth = menuOpen ? 250 : 70;

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
        minHeight: '100vh',
        background: '#0c1f1d',
        paddingLeft: sidebarWidth,
        transition: 'padding-left .25s ease'
      }}
    >
      <MenuOperaciones
        defaultOpen={menuOpen}
        onToggle={(next) => setMenuOpen(next)}  // actualiza margen del contenido
      />

      <main
        className="contenido-panel"
        style={{
          flex: 1,
          minWidth: 0,
          transition: 'margin-left .25s ease',
          padding: 20,
          background: 'radial-gradient(900px 600px at -10% -10%, #183c34 0%, transparent 45%), #0c1f1d'
        }}
      >
        <OperacionesDia/>
      </main>
    </div>
  );
}

export default VerOperacionesDia;
